module.exports = __webpack_public_path__ + "static/blorg-79fcc30f4b2bbdac84d12077677aedae.svg";